import React from 'react';

var MobileStructureBottom = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-m-game-structure-bottom' }, children));
};

export { MobileStructureBottom };
